import { jsx as _jsx } from "react/jsx-runtime";

function SvgAlert() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM11 8a1 1 0 112 0v5a1 1 0 11-2 0V8zm1 9a1 1 0 100-2 1 1 0 000 2z"
    }, void 0)
  }), void 0);
}

export default SvgAlert;